import IsServerSideRendering from './IsServerSideRendering';

const availabilityTestKey = 'cvna_localstorage_availability_test';
const ok = 'OK';

const isLocalStorageEnabledCheck = () => {
  if (IsServerSideRendering) {
    return false;
  }

  if (typeof localStorage !== 'undefined') {
    try {
      localStorage.setItem(availabilityTestKey, ok);
      if (localStorage.getItem(availabilityTestKey) === ok) {
        localStorage.removeItem(availabilityTestKey);
        return true;
      }
    } catch (e) {
      // localStorage is disabled
    }
  }
  return false;
};

const IsLocalStorageEnabled = isLocalStorageEnabledCheck();

export default IsLocalStorageEnabled;
